import * as stylex from "@stylexjs/stylex";
import { useEffect, useRef } from "react";
import "@/theme/tokens.stylex";
import { shadows } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Button } from "./Button";
type DiscardMessageProps = {
  title: string;
  body: string;
};
type DiscardButtonsProps = {
  keepLabel: string;
  discardLabel: string;
  onKeep: () => void;
  onDiscard: () => void;
};
const styles = {
  keep: {
    kGVxlE: "xnfxhx2",
    $$css: true
  }
};
export function DiscardMessage({
  title,
  body
}: DiscardMessageProps) {
  return <div role="alert" className="x78zum5 xdt5ytf x1jnr06f xeuugli">
      <span className="x1iig92y xhxcbl2 x1hrmo45 x1u7k74">{title}</span>
      <span className="x1n63bex xbt1u0e x37zpob x1fzhlzt">{body}</span>
    </div>;
}
export function DiscardButtons({
  keepLabel,
  discardLabel,
  onKeep,
  onDiscard
}: DiscardButtonsProps) {
  const keep = useFocusWhileShown();
  return <>
      <Button ref={keep} variant="secondary" onClick={onKeep} xstyle={styles.keep}>
        {keepLabel}
      </Button>
      <Button variant="danger" onClick={onDiscard}>
        {discardLabel}
      </Button>
    </>;
}
function useFocusWhileShown() {
  const keep = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const dialog = keep.current?.closest<HTMLElement>("[role=dialog]");
    keep.current?.focus();
    return () => {
      if (document.activeElement === document.body) dialog?.focus();
    };
  }, []);
  return keep;
}